<template>
  <v-app id="inspire">
    <v-card-title>
      <v-row>
        <v-col class="center" cols="12" sm="6" offset-sm="2">
          <v-icon size="800%" color="success">mdi-check</v-icon>
          <div>
            <h2>{{this.title}}</h2>
            <h3>
              We will reach out to you with a decision within 1 business day.
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
  </v-app>
</template>

<script>
export default {
  name: 'OCRSubmitted',
  data() {
    return {
      title: 'Application Submitted',
    };
  },
};
</script>

<style scoped>
.center {
    text-align: center;
    color: #387002;
}
</style>
